import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import FAQ from '../components/FAQ';
import { handleDownloadClick } from '../utils/deviceDetection';
import usePageMeta from '../hooks/usePageMeta';

function FAQPage() {
  usePageMeta({
    title: 'FAQ - WearTwice | Buying & Selling Pre-Loved Fashion in the UAE',
    description: 'Answers about buying, selling, shipping, payments and Buyer Protection on WearTwice, the UAE marketplace for pre-loved fashion.',
    path: '/faq',
  });

  return (
    <main className="w-full">
      {/* Header */}
      <section className="bg-[#137C63] py-12 md:py-16">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-8">
            <Link to="/">
              <img
                src="/images/logo_full.svg"
                alt="WearTwice Logo"
                width="179"
                height="72"
              />
            </Link>
          </div>

          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-4">
              Frequently Asked Questions
            </h1>
            <p className="text-xl text-white max-w-3xl mx-auto">
              Find answers about buying and selling pre-loved fashion in Dubai, Abu Dhabi, and across the UAE
            </p>
          </div>
        </div>
      </section>

      {/* Full FAQ */}
      <FAQ showTitle={false} />

      {/* CTA Section */}
      <section className="bg-[#F3F4F0] py-12 md:py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#062319] mb-6">
            Still have questions?
          </h2>
          <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
            Download the WearTwice app and explore the easiest way to buy and sell pre-loved fashion in the UAE
          </p>
          <Link to="/qr-code" onClick={handleDownloadClick} className="inline-block py-4 px-8 text-[#DDFDB3] bg-[#062319] rounded-xl hover:bg-[#093728] transition-colors font-bold">
            Download WearTwice
          </Link>
        </div>
      </section>

      <Footer />
    </main>
  );
}

export default FAQPage;
